import { render, staticRenderFns } from "./CheckInNonAttivato.vue?vue&type=template&id=23d0edcb&scoped=true&"
import script from "./CheckInNonAttivato.vue?vue&type=script&lang=js&"
export * from "./CheckInNonAttivato.vue?vue&type=script&lang=js&"
import style0 from "./CheckInNonAttivato.vue?vue&type=style&index=0&id=23d0edcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0edcb",
  null
  
)

export default component.exports